import logo from "../assets/iRise-psychology-Logo1.png";


export default function Navbar() {
  return (
    // sticky-top (removed)
    <header className=" bg-white border-bottom">
      <nav className="navbar navbar-expand-lg bg-white w-100">
        <div className="py-2 main-wrap w-100">
          <div className="d-flex align-items-center justify-content-between w-100">
            <a
              className="navbar-brand d-flex align-items-center gap-2 mb-0"
              href="#"
            >
              <img
                src={logo}
                alt="iRise Psychology"
                className="navbar-brand-logo"
              />
            </a>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mainNav"
              aria-controls="mainNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav ms-lg-auto align-items-lg-center gap-lg-2 mt-3 mt-lg-0 ">
              <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light" href="#welcome">
                  Welcome
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light" href="#team">
                  Team
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light" href="#locations">
                  Find Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light" href="#therapy">
                  Therapy Offered
                </a>
              </li>
     
           <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light"  href="#areasofsupport">
                  Areas Of Support
                </a>
              </li>

                     <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light"  href="#fees">
                  Fees
                </a>
              </li>
                             <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light"  href="#faq">
                  FAQ
                </a>
              </li>

                                  <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light"  href="#reviews">
                  Reviews
                </a>
              </li>

              
              <li className="nav-item">
                <a className="nav-link fw-bold brand-text-light"  href="#contact">
                  Contact Us
                </a>
              </li>

              


              
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}
